import React, {
  useMemo,
  useState,
  useRef,
  useEffect,
  useCallback,
} from "react";
import { ScSelectMultiple } from "./styled";
import { ChevronDown } from "react-feather";

type Value = string | number;

type Option = {
  label: string;
  value: Value;
};

interface SelectMultipleProps {
  value?: Array<Value> | Value;
  options: Option[];
  onChange: (values: Array<Value> | Value) => void;
  multiple?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

const SelectMultiple: React.FC<SelectMultipleProps> = ({
  value,
  options,
  onChange,
  multiple,
  style,
  className,
}) => {
  if (multiple && !Array.isArray(value)) return <></>;

  const selectContainer = useRef<HTMLDivElement>(null);

  const handleChange = useCallback(
    (v) => {
      if (!Array.isArray(value)) {
        onChange(v);
        return;
      }
      if (value?.includes(v)) {
        onChange(value?.filter((i) => i !== v));
      } else {
        onChange([...value, v]);
      }
    },
    [onChange, value]
  );

  useEffect(() => {
    const closeOptions = (e: MouseEvent) => {
      e.stopPropagation();
      if (!selectContainer?.current?.contains(e.target as Node)) {
        setShowOptions(false);
      }
    };

    window.addEventListener("click", closeOptions);

    return () => {
      window.removeEventListener("click", closeOptions);
    };
  }, []);

  const valueTitle = useMemo(() => {
    if (!Array.isArray(value)) {
      return value;
    }
    if (value.length === 1) {
      return options.find((i) => i.value === value[0])?.label;
    } else if (value.length === 0) {
      return "Выберите паталогии";
    } else {
      return "Выбрано несколько паталогий";
    }
  }, [value]);

  const [showOptions, setShowOptions] = useState(false);
  return (
    <ScSelectMultiple>
      <div ref={selectContainer} style={style} className={className}>
        <div
          className="select-label"
          onClick={() => setShowOptions(!showOptions)}
        >
          <span className="title">{valueTitle}</span>
          <ChevronDown size={16} />
        </div>
        {showOptions && (
          <div className="options-container">
            <div className="options">
              {options.map((option) => (
                <div
                  className="option"
                  key={option.value}
                  onClick={() => handleChange(option.value)}
                >
                  {Array.isArray(value) ? (
                    <input
                      type="checkbox"
                      readOnly
                      checked={value.some((i) => i === option.value)}
                    />
                  ) : (
                    <input
                      type="checkbox"
                      readOnly
                      checked={value === option.value}
                    />
                  )}
                  <span>{option.label}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </ScSelectMultiple>
  );
};

export default React.memo(SelectMultiple);
